import db from "@/firebaseConfig";
import Engine from "@/components/products/Engine";
import Contact from "@/components/contact/contact";
import Exhibition from "@/components/news/Exhibition";
import EngineProxy from "@/components/products/EngineProxy";

export class DBService {
    static dbService: DBService;
    private slideshow: any[] = [];
    private engine: Engine | undefined;
    private proxies: EngineProxy[] = [];
    private contacts: Contact[] = [];
    private jobs: any[] = [];
    private history: any[] = [];
    private exhibitions: any[] = [];
    private innovation: any[] = [];
    private clamping_imgs: any[] = [];
    private clamping_advantages: any[] = [];
    private clamping_data: any[] = [];
    private locale = localStorage.getItem("lang");
    private downloads: any[] = [];

    static getInstance(): DBService {
        if (!DBService.dbService) {
            DBService.dbService = new DBService();
        }
        return DBService.dbService;
    }

    async getSlideShow() {
        let slides: any = [];
        await db.collection('home').doc('slideshow').get().then(function (doc) {
            slides = doc.data();
        })
        return this.slideshow = slides;
    }

    async getProxies() {
        if (this.proxies.length === 0) {
            const snapshot = await db.collection('engines_proxy')
                .withConverter(this.proxyConverter)
                .orderBy('position')
                .get();
            this.proxies = snapshot.docs.map(doc => doc.data());
        }
        return this.proxies;
    }

    async getEngineById(id: string) {
        let engine;
        if (this.locale) {
            const enginesRef = db.collection("engines_".concat(this.locale));
            const doc = await enginesRef.doc(id).withConverter(this.engineConverter).get();
            engine = doc.data();
        } else {
            const enginesRef = db.collection("engines_de");
            const doc = await enginesRef.doc(id).withConverter(this.engineConverter).get();
            engine = doc.data();
        }
        this.engine = engine;
        return this.engine;
    }

    async getClampingImgs() {
        const clampingRef = db.collection('clamping_tools');
        const doc = await clampingRef.doc('imgs').get();
        const data = doc.data();
        this.clamping_imgs = Array.isArray(data) ? data : [];
        return this.clamping_imgs;
    }

    async getClampingAdvantages() {
        const clampingRef = db.collection('clamping_tools');
        const doc = await clampingRef.doc('advantages').get();
        const data = doc.data();
        this.clamping_advantages = Array.isArray(data) ? data : [];
        return this.clamping_advantages;
    }

    async getClampingData() {
        const clampingRef = db.collection('clamping_tools');
        const doc = await clampingRef.doc('technical_data').get();
        const data = doc.data();
        this.clamping_data = Array.isArray(data) ? data : [];
        return this.clamping_data;
    }

    async getHistory() {
        if (this.history.length === 0) {
            const snapshot = await db.collection('history').orderBy("year", "desc").get();
            this.history = snapshot.docs.map(doc => doc.data());
        }
        return this.history;
    }


    async getContacts() {
            const snapshot = await db.collection('contacts')
                .withConverter(this.contactConverter)
                .orderBy('id')
                .get();
            this.contacts = snapshot.docs.map(doc => doc.data());
        return this.contacts;
    }

    async getJobs() {
        return new Promise((resolve) => {
            db.collection('career').onSnapshot({includeMetadataChanges: false}, (snapShot) => {
                this.jobs = [];
                snapShot.forEach((job) => {
                    this.jobs.push(job.data());
                });
                resolve(this.jobs);
            });
        });
    }

    async getDownloads() {
        return new Promise((resolve) => {
            db.collection('downloads').onSnapshot({includeMetadataChanges: false}, (snapShot) => {
                this.downloads = [];
                snapShot.forEach((download) => {
                    this.downloads.push(download.data());
                });
                resolve(this.downloads);
            });
        });
    }

    async getExhibitions() {
        if (this.exhibitions.length <= 0) {
            db.collection('news').withConverter(this.exhibitionConverter).onSnapshot({includeMetadataChanges: false}, (snapShot) => {
                snapShot.forEach((exhibition) => {
                    this.exhibitions.push(exhibition.data());
                });
            });
        }
        return this.exhibitions
    }

    async getInnovation() {
        if (this.innovation.length <= 0) {
            db.collection('innovation').onSnapshot({includeMetadataChanges: false}, (snapShot) => {
                snapShot.forEach((inno) => {
                    this.innovation.push(inno.data());
                });
            });
        }
        return this.innovation
    }

    proxyConverter = {
        toFirestore: function (proxy: EngineProxy) {
            return {
                id: proxy.id,
                name: proxy.name,
                position: proxy.position,
                subtitle: proxy.subtitle,
                type: proxy.type,
                thumbnail: proxy.thumbnail
            }
        },

        fromFirestore: function (snapshot: any, options: any) {
            const data = snapshot.data(options);
            return new EngineProxy(data.id, data.name, data.position, data.subtitle, data.thumbnail, data.type);
        }
    }

    engineConverter = {
        toFirestore: function (engine: Engine) {
            return {
                id: engine.id,
                name: engine.name,
                header: engine.header,
                imgs: engine.imgs,
                technical_data: engine.technical_data,
                notes: engine.notes,
                description: engine.description,
                advantages: engine.advantages
            }
        },
        fromFirestore: function (snapshot: any, options: any) {
            const data = snapshot.data(options);
            return new Engine(data.id, data.name, data.header, data.imgs, data.technical_data,
                data.notes, data.description, data.advantages)
        }
    }

    contactConverter = {
        toFirestore: function (contact: Contact) {
            return {
                id: contact.id,
                img: contact.img,
                location: contact.location,
                firstname: contact.firstname,
                lastname: contact.lastname,
                phone: contact.phone,
                mail: contact.mail,
                fax: contact.fax,
                adress: contact.adress
            }
        },

        fromFirestore: function (snapshot: any, options: any) {
            const data = snapshot.data(options);
            return new Contact(data.id, data.img, data.location, data.firstname, data.lastname, data.phone, data.mail,
                data.fax, data.adress);

        }
    }

    exhibitionConverter = {
        toFirestore: function (exhibition: Exhibition) {
            return {
                id: exhibition.id,
                img: exhibition.img,
                name: exhibition.name,
                description: exhibition.description,
                start: exhibition.start,
                end: exhibition.end,
                city: exhibition.city,
                country: exhibition.country,
                href: exhibition.href,
            }
        },

        fromFirestore: function (snapshot: any, options: any) {
            const data = snapshot.data(options);
            return new Exhibition(data.id, data.img, data.name, data.description, data.startDate.toDate(), data.endDate.toDate(), data.city, data.country, data.href);
        }
    }
}